module.exports = __webpack_public_path__ + "static/media/media-record.f6d96682.png";